import { useEffect } from 'react';

const SITE_NAME = '91在线视频';

export function usePageMeta(title?: string, description?: string, keywords?: string) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name: string, content?: string) => {
      if (!content) return;
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('description', description);
    setMeta('keywords', keywords);
  }, [title, description, keywords]);
}

export { SITE_NAME };